import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "description", "title"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { H4 } from 'foundations-components/transitional/components/H4';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "Section__StyledDiv",
  componentId: "pq0sr6-0"
})(["margin-block-start:", ";margin-block-end:", ";", ""], ({
  theme
}) => theme.space['700'], ({
  theme
}) => theme.space['700'], ({
  $cssStyles
}) => $cssStyles);

/**
 * Sections exist in the contents of the page to provide a consistent structure, spacing, and formatting to the settings area. At least one type of section is **required** on every settings page.
 */
const Section = props => {
  const {
      children,
      className,
      description,
      title
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const descriptionStyles = description ? '0 !important' : undefined;
  const {
    tokenProps,
    restProps
  } = filterTokenProps(rest);
  const cssProps = useMapTokenPropsToCSS(tokenProps);
  if (title && !description) {
    console.error('Settings Section: description property required when using title property');
  }
  return /*#__PURE__*/_jsxs(StyledDiv, Object.assign({
    className: classNames('settings-module', className),
    "data-test-id": "settings-module",
    $cssStyles: cssProps
  }, restProps, {
    children: [title && /*#__PURE__*/_jsx(H4, {
      marginBlockEnd: descriptionStyles,
      "aria-level": 3,
      children: title
    }), description && /*#__PURE__*/_jsx(View, {
      maxInlineSize: "900px",
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        use: "default",
        marginBlockEnd: "400",
        children: description
      })
    }), children]
  }));
};
Section.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  /**
   * Heading for this section.
   */
  title: PropTypes.node,
  /**
   * Description for content within this section.
   */
  description: PropTypes.node
};
export default Section;